<template>
    <div v-if="!modernCabinet" class="dashboard" :class="{mobile: isMobile}" :style="{'--totals-rows': Math.round(totalsWrapperCount / 2)}">
        <div class="accounts-select">
             <div class="form-row fs">
                    <label class="fs">Accounts</label>
                    <select 
                        class="form-control fs" 
                        @change="changeAccount($event.target.value)" 
                        v-model="selectedAccount"
                        :disabled="disableSelectedAccount"
                    >
                        <option :value="account.id" v-for="account in accounts" :key="account.id">
                            <span>{{ buildAccountName(account) }} (#{{account.id}})</span>
                        </option>
                    </select>
            </div>
        </div>
        <div class="totals-wrapper" ref="totalsWrapper">
            <div class="total-balance">
                <div class="left">
                    <img :src="`../image/misc/goblet.png`">
                </div>
                <div class="right">
                    <h4 class="title">{{ tokens.fullScreenDashboard.totalBalance }}</h4>
                    <p class="value"
                       :class="totalBalance < 0 ? 'red-gradient' : (totalBalance >= 0 ? 'green-gradient' : '')">
                        {{
                            activeCurrency && totalBalance >= 0 ? currencySign(activeCurrency) + totalBalance.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : `${currencySign('USD')} 0`
                        }}</p>
                    <span v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</span>
                </div>
            </div>
            <div class="total-pnl">
                <div class="left">
                    <img :src="`../image/misc/gem.png`">
                </div>
                <div class="right">
                    <h4 class="title">{{ tokens.fullScreenDashboard.totalPnl }}</h4>
                    <p class="value"
                       :class="pnl < 0 ? 'red-gradient' : pnl >= 0 ? 'green-gradient' : 'green-gradient'">
                        {{
                            activeCurrency ? currencySign(activeCurrency) + pnl.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : `${currencySign('USD')} 0`
                        }}
                    </p>
                    <span v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</span>
                </div>
            </div>
            <div class="profitable-orders">
                <div class="left">
                    <img :src="`../image/misc/target.png`">
                </div>
                <div class="right">
                    <h4 class="title">{{ tokens.fullScreenDashboard.profitableOrders }}</h4>
                    <p class="value green-gradient">
                        {{ dashboardData.stats.cnt_profit ? dashboardData.stats.cnt_profit : "0" }} / {{ cntTotal }}</p>
                </div>
            </div>
            <div v-if="!hideTotalDeposits" class="roi">
                <div class="left">
                    <img :src="`../image/misc/totalDeposit.png`">
                </div>
                <div class="right">
                    <h4 class="title">{{ tokens.fullScreenDashboard[showTaxes ? 'totalTaxes' : 'totalDeposits'] }}</h4>
                    <p class="value roi-value"
                       :class="dashboardData.stats.deposits < 0 ? 'red-gradient' : 'green-gradient'">
                        {{
                            activeCurrency && showTaxes ? (totalTaxes > 0 ? currencySign(activeCurrency) + totalTaxes.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : `${currencySign(activeCurrency ? activeCurrency : 'USD')} 0`) : (totalDeposits > 0 ? currencySign(activeCurrency) + totalDeposits.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : `${currencySign(activeCurrency ? activeCurrency : 'USD')} 0`)
                        }}
                    </p>
                    <span v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</span>
                </div>
            </div>
            <div v-if="isShowEquity()" class="equity">
                <div class="left">
                    <img :src="`../image/misc/goblet.png`">
                </div>
                <div class="right">
                    <h4 class="title">{{ 'Account Equity' }}</h4>
                    <p class="value"
                       :class="totalBalance < 0 ? 'red-gradient' : (totalBalance >= 0 ? 'green-gradient' : '')">
                       {{
                                currencySign(activeAccount.currency) + (
                                 getEquity.equity_apprx > 0 ? getEquity.equity_apprx : 0).toLocaleString(undefined, {
                                    minimumFractionDigits: activeAccount.precision,
                                    maximumFractionDigits: activeAccount.precision
                                })
                            }}</p>
                    <span v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</span>
                </div>
            </div>
            <div v-if="showWithdrawal" class="total-withdrawal">
                <div class="left">
                    <img :src="`../image/misc/totalDeposit.png`">
                </div>
                <div class="right">
                    <h4 class="title">{{ 'Total Withdrawal' }}</h4>
                    <p class="value"
                       :class="totalWithdrawal < 0 ? 'red-gradient' : (totalWithdrawal >= 0 ? 'green-gradient' : '')">
                        {{
                            activeCurrency && totalWithdrawal >= 0 ? currencySign(activeCurrency) + totalWithdrawal.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : `${currencySign('USD')} 0`
                        }}</p>
                    <span v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</span>
                </div>
            </div>
            <div v-if="showNetDeposits" class="total-net-deposits">
                <div class="left">
                    <img :src="`../image/misc/gem.png`">
                </div>
                <div class="right">
                    <h4 class="title">{{ 'Net Deposits' }}</h4>
                    <p class="value"
                       :class="totalNetDeposits < 0 ? 'red-gradient' : (totalNetDeposits >= 0 ? 'green-gradient' : '')">
                        {{
                            activeCurrency && totalNetDeposits >= 0 ? currencySign(activeCurrency) + totalNetDeposits.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : `${currencySign('USD')} 0`
                        }}</p>
                </div>
            </div>
        </div>

        <div class="chart-line" v-if="!showTaxes">
            <div class="chart-line-head" v-if="!hideTradingResult">
                <h4>{{ tokens.fullScreenDashboard.tradingResults }}</h4>
                <div class="time" v-if="!hideTradingResult">
                    <button class="time-item fs-small" :class="{active: timeframe === 'Week'}"
                            @click="changeTimeframe('Week',7)">{{ tokens.fullScreenDashboard.week }}
                    </button>
                    <button class="time-item fs-small" :class="{active: timeframe === 'Month'}"
                            @click="changeTimeframe('Month',30)">{{ tokens.fullScreenDashboard.month }}
                    </button>
                </div>
            </div>
            <div style="display: grid; height: 100%" v-if="!hideTradingResult"> <!-- hack for highchart height -->
                <highcharts :options="chartOptionsLine" ref="lineChart"/>
            </div>
        </div>
        <div class="chart-line" v-else>
            <table class="cabinet fs">
                <thead>
                <tr class="fs">
                    <th class="nomobile fs" v-if="!hideDashboardTime">{{ tokens.fullScreenDeposit.time.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenDeposit.amount.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenDeposit.currency.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenDeposit.info.toUpperCase() }}</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="tax in taxes"
                    :key="tax.id"
                    class="fs"
                >
                    <td class="nomobile fs" v-if="!hideDashboardTime">{{ new Date(tax.time_created * 1000).getFullYear() }}</td>
                    <td class="fs">{{ currencySign(tax.currency)+tax.amount.toFixed(2) }}</td>
                    <td class="fs">{{ tax.currency }}</td>
                    <td class="fs">{{ tax.comment }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="totalsWrapperCount" class="chart-pie">
            <h4>{{ tokens.fullScreenDashboard.successRate }}</h4>
            <div style="display: grid; height: 100%"> <!-- hack for highchart height -->
                <highcharts :options="chartOptionsPie" ref="pieChart"/>
            </div>
        </div>
        <div class="account" v-for="account in accounts ? accounts : ''"
             :key="account.id"
             :class="{
                        active: account && activeAccount.id === account.id,
                        real: account && !account.demo,
                        demo: account && account.demo
                    }">
            <div class="head">
                <h3>{{ tokens.fullScreenDashboard.account }}</h3>
                <div class="balances">
                    <img :src="plate[account.id]">
                    <img class="sign balance" :src="`../image/currencies/${account.currency}.png`" alt="">
                </div>
            </div>
            <div class="body">
                <div class="info">
                    <h4>{{ tokens.fullScreenDashboard.balance }}</h4>
                    <p class="value"
                       :class="account.balance < 0 ? 'red-gradient' : (account.balance >= 0 ? 'green-gradient' : '')">
                        {{
                            currencySign(account.currency) + ' ' + (account.balance > 0 ? account.balance : 0).toLocaleString(undefined, {
                                minimumFractionDigits: account.precision,
                                maximumFractionDigits: account.precision
                            })
                        }}</p>
                </div>
                <div class="info" v-show="parseInt(showLeverage) === 1">
                    <h4>{{ tokens.fullScreenDashboard.leverage }}</h4>
                    <p class="value"
                       :class="account.leverage < 0 ? 'red-gradient' : (account.leverage >= 0 ? 'green-gradient' : '')">
                        {{ '1:' + account.leverage }}</p>
                </div>
                <div class="info">
                    <h4>{{ tokens.fullScreenDashboard.credit }}</h4>
                    <p class="value"
                       :class="account.credit < 0 ? 'red-gradient' : (account.credit >= 0 ? 'green-gradient' : '')">
                        {{
                            currencySign(account.currency) + ' ' + (account.credit).toLocaleString(undefined, {
                                minimumFractionDigits: account.precision,
                                maximumFractionDigits: account.precision
                            })
                        }}</p>
                </div>
            </div>
            <div class="footer" v-if="!moduleFtd">
                <button class="fs" @click="makeActive(account.id)">{{ tokens.fullScreenDashboard.tradeNow }}</button>
            </div>
        </div>
    </div>
    <!-- clean-fintech makeover (CABINET_DESIGN === 'clean'); same data bindings 1:1, fresh dash-* classes -->
    <div v-else class="dash-modern" :class="{mobile: isMobile}">
        <div class="dash-greeting">
            <div class="dash-greeting-left">
                <h2 class="dash-welcome">Welcome back, {{ user.fullname }}</h2>
                <span class="cab-badge" v-if="activeAccount && activeAccount.group">{{ buildAccountName(activeAccount) }}</span>
            </div>
            <div class="dash-greeting-right">
                <label class="dash-select-label">Accounts</label>
                <select
                    class="cab-select"
                    @change="changeAccount($event.target.value)"
                    v-model="selectedAccount"
                    :disabled="disableSelectedAccount"
                >
                    <option :value="account.id" v-for="account in accounts" :key="account.id">
                        {{ buildAccountName(account) }} (#{{ account.id }})
                    </option>
                </select>
            </div>
        </div>
        <div class="dash-stats" ref="totalsWrapper">
            <div class="cab-stat">
                <div class="cab-stat-label">{{ tokens.fullScreenDashboard.totalBalance }}</div>
                <div class="cab-stat-value"
                     :class="totalBalance < 0 ? 'cab-red' : (totalBalance >= 0 ? 'cab-green' : '')">
                    {{
                        activeCurrency && totalBalance >= 0 ? currencySign(activeCurrency) + totalBalance.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : `${currencySign('USD')} 0`
                    }}
                </div>
                <div class="dash-stat-note" v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</div>
            </div>
            <div class="cab-stat">
                <div class="cab-stat-label">{{ tokens.fullScreenDashboard.totalPnl }}</div>
                <div class="cab-stat-value"
                     :class="pnl < 0 ? 'cab-red' : pnl >= 0 ? 'cab-green' : 'cab-green'">
                    {{
                        activeCurrency ? currencySign(activeCurrency) + pnl.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : `${currencySign('USD')} 0`
                    }}
                </div>
                <div class="dash-stat-note" v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</div>
            </div>
            <div class="cab-stat">
                <div class="cab-stat-label">{{ tokens.fullScreenDashboard.profitableOrders }}</div>
                <div class="cab-stat-value cab-green">
                    {{ dashboardData.stats.cnt_profit ? dashboardData.stats.cnt_profit : "0" }} / {{ cntTotal }}
                </div>
            </div>
            <div v-if="!hideTotalDeposits" class="cab-stat">
                <div class="cab-stat-label">{{ tokens.fullScreenDashboard[showTaxes ? 'totalTaxes' : 'totalDeposits'] }}</div>
                <div class="cab-stat-value"
                     :class="dashboardData.stats.deposits < 0 ? 'cab-red' : 'cab-green'">
                    {{
                        activeCurrency && showTaxes ? (totalTaxes > 0 ? currencySign(activeCurrency) + totalTaxes.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : `${currencySign(activeCurrency ? activeCurrency : 'USD')} 0`) : (totalDeposits > 0 ? currencySign(activeCurrency) + totalDeposits.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : `${currencySign(activeCurrency ? activeCurrency : 'USD')} 0`)
                    }}
                </div>
                <div class="dash-stat-note" v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</div>
            </div>
            <div v-if="isShowEquity()" class="cab-stat">
                <div class="cab-stat-label">{{ 'Account Equity' }}</div>
                <div class="cab-stat-value"
                     :class="totalBalance < 0 ? 'cab-red' : (totalBalance >= 0 ? 'cab-green' : '')">
                    {{
                        currencySign(activeAccount.currency) + (
                            getEquity.equity_apprx > 0 ? getEquity.equity_apprx : 0).toLocaleString(undefined, {
                            minimumFractionDigits: activeAccount.precision,
                            maximumFractionDigits: activeAccount.precision
                        })
                    }}
                </div>
                <div class="dash-stat-note" v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</div>
            </div>
            <div v-if="showWithdrawal" class="cab-stat">
                <div class="cab-stat-label">{{ 'Total Withdrawal' }}</div>
                <div class="cab-stat-value"
                     :class="totalWithdrawal < 0 ? 'cab-red' : (totalWithdrawal >= 0 ? 'cab-green' : '')">
                    {{
                        activeCurrency && totalWithdrawal >= 0 ? currencySign(activeCurrency) + totalWithdrawal.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : `${currencySign('USD')} 0`
                    }}
                </div>
                <div class="dash-stat-note" v-if="!dashboardAccountCurrency">* {{ tokens.fullScreenDashboard.usingCurrentRate }}</div>
            </div>
            <div v-if="showNetDeposits" class="cab-stat">
                <div class="cab-stat-label">{{ 'Net Deposits' }}</div>
                <div class="cab-stat-value"
                     :class="totalNetDeposits < 0 ? 'cab-red' : (totalNetDeposits >= 0 ? 'cab-green' : '')">
                    {{
                        activeCurrency && totalNetDeposits >= 0 ? currencySign(activeCurrency) + totalNetDeposits.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : `${currencySign('USD')} 0`
                    }}
                </div>
            </div>
        </div>
        <div class="dash-cols">
            <div class="cab-card dash-chart" v-if="!showTaxes">
                <div class="cab-card-title" v-if="!hideTradingResult">
                    <span>{{ tokens.fullScreenDashboard.tradingResults }}</span>
                    <div class="dash-time">
                        <button class="dash-time-btn" :class="{active: timeframe === 'Week'}"
                                @click="changeTimeframe('Week',7)">{{ tokens.fullScreenDashboard.week }}
                        </button>
                        <button class="dash-time-btn" :class="{active: timeframe === 'Month'}"
                                @click="changeTimeframe('Month',30)">{{ tokens.fullScreenDashboard.month }}
                        </button>
                    </div>
                </div>
                <div style="display: grid; height: 100%" v-if="!hideTradingResult"> <!-- hack for highchart height -->
                    <highcharts :options="chartOptionsLine" ref="lineChart"/>
                </div>
            </div>
            <div class="cab-card dash-chart" v-else>
                <table class="cab-table">
                    <thead>
                    <tr>
                        <th v-if="!hideDashboardTime">{{ tokens.fullScreenDeposit.time.toUpperCase() }}</th>
                        <th>{{ tokens.fullScreenDeposit.amount.toUpperCase() }}</th>
                        <th>{{ tokens.fullScreenDeposit.currency.toUpperCase() }}</th>
                        <th>{{ tokens.fullScreenDeposit.info.toUpperCase() }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="tax in taxes"
                        :key="tax.id"
                    >
                        <td v-if="!hideDashboardTime">{{ new Date(tax.time_created * 1000).getFullYear() }}</td>
                        <td>{{ currencySign(tax.currency)+tax.amount.toFixed(2) }}</td>
                        <td>{{ tax.currency }}</td>
                        <td>{{ tax.comment }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="totalsWrapperCount" class="cab-card dash-pie">
                <div class="cab-card-title">{{ tokens.fullScreenDashboard.successRate }}</div>
                <div style="display: grid; height: 100%"> <!-- hack for highchart height -->
                    <highcharts :options="chartOptionsPie" ref="pieChart"/>
                </div>
            </div>
        </div>
        <div class="cab-card dash-accounts">
            <div class="cab-card-title">Accounts</div>
            <table class="cab-table">
                <thead>
                <tr>
                    <th>{{ tokens.fullScreenDashboard.account }}</th>
                    <th class="num">{{ tokens.fullScreenDashboard.balance }}</th>
                    <th class="num" v-show="parseInt(showLeverage) === 1">{{ tokens.fullScreenDashboard.leverage }}</th>
                    <th class="num">{{ tokens.fullScreenDashboard.credit }}</th>
                    <th v-if="!moduleFtd"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="account in accounts ? accounts : ''"
                    :key="account.id"
                    :class="{active: account && activeAccount.id === account.id}">
                    <td>
                        {{ buildAccountName(account) }}
                        <span class="dash-acc-id">#{{ account.id }} · {{ account.currency }}</span>
                        <span class="cab-badge" v-if="account && activeAccount.id === account.id">Active</span>
                    </td>
                    <td class="num"
                        :class="account.balance < 0 ? 'cab-red' : (account.balance >= 0 ? 'cab-green' : '')">
                        {{
                            currencySign(account.currency) + ' ' + (account.balance > 0 ? account.balance : 0).toLocaleString(undefined, {
                                minimumFractionDigits: account.precision,
                                maximumFractionDigits: account.precision
                            })
                        }}
                    </td>
                    <td class="num" v-show="parseInt(showLeverage) === 1"
                        :class="account.leverage < 0 ? 'cab-red' : (account.leverage >= 0 ? 'cab-green' : '')">
                        {{ '1:' + account.leverage }}
                    </td>
                    <td class="num"
                        :class="account.credit < 0 ? 'cab-red' : (account.credit >= 0 ? 'cab-green' : '')">
                        {{
                            currencySign(account.currency) + ' ' + (account.credit).toLocaleString(undefined, {
                                minimumFractionDigits: account.precision,
                                maximumFractionDigits: account.precision
                            })
                        }}
                    </td>
                    <td class="num" v-if="!moduleFtd">
                        <button class="cab-btn dash-trade-btn" @click="makeActive(account.id)">{{ tokens.fullScreenDashboard.tradeNow }}</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {currencySign, isMobile, localStorage} from '@/common/helpers'
import {
    PLATES_FOLDER,
    BRAND,
    SHOW_LEVERAGE,
    MODULE_FTD,
    HIDE_TRADING_RESULT, 
    SHOW_TAXES, 
    HIDE_DASHBOARD_TIME,
    SHOW_EQUITY_HEADER,
    HIDE_TOTAL_DEPOSITS,
    SHOW_TOTAL_WITHDRAWALS,
    SHOW_TOTAL_NET_DEPOSITS,
    CABINET_DESIGN,
} from "@/common/config";
import {ACCOUNT_ACTIVE, ACTIVE_CURRENCY, MODAL} from "@/store/mutations.type";
import {DASHBOARD_BALANCE} from "@/store/actions.type";

export default {
    name: 'Dashboard',
    mounted() {
        let dashboardBalance = this.dashboardData.balance_chart
        let data = []
        for (let i = 0; i < dashboardBalance.length; i++) {
            data[i] = dashboardBalance[i][1]
        }
        this.chartOptionsLine.series[0].data = data
        this.foundMinMax()
        this.dashboardChartInit()

        this.updateTotalsWrapperCount();

        this.chartOptionsPie.legend.itemStyle.color = this.brand === 'coinxe' ? '#000000' : '#235fb7'
    },
    data() {
        return {
            isMobile: isMobile(),
            brand: BRAND,
            hideDashboardTime: HIDE_DASHBOARD_TIME,
            platesFolder: PLATES_FOLDER,
            showLeverage: SHOW_LEVERAGE,
            moduleFtd: MODULE_FTD,
            showTaxes: SHOW_TAXES,
            showWithdrawal: SHOW_TOTAL_WITHDRAWALS,
            showNetDeposits: SHOW_TOTAL_NET_DEPOSITS,
            hideTradingResult: HIDE_TRADING_RESULT,
            time: 7,
            timeframeData: [],
            timeframe: 'Week',
            balanceChart: [],
            allTime: [],
            chartOptionsLine: {
                title: false,
                credits: false,
                chart: {
                    backgroundColor: 'transparent',
                    type: 'areaspline',
                },
                plotOptions: {
                    areaspline: {
                        fillOpacity: 0.5
                    },
                    series: {
                        fillColor: {
                            linearGradient: [0, 0, 50, 300],
                            stops: [
                                [0, '#1d98f9'],
                                [1, 'rgba(24,31,45,0.5)']
                            ]
                        },

                    }
                },
                legend: true,
                xAxis: {
                    labels: {
                        style: {
                            fontSize: '0px'
                        },
                    },
                    gridLineWidth: 0,
                    tickLength: 0,
                    min: 0,
                    categories: []
                },
                yAxis: {
                    title: {
                        text: null,
                    },
                    labels: {
                        style: {
                            fontSize: '0px'
                        },
                    },
                    min: 0,
                    gridLineWidth: 0,
                    tickLength: 0,
                    display: true,
                },
                lineWidth: 1,
                threshold: null,
                // innerSize: '60%',
                enableMouseTracking: true,

                tooltip: {
                    headerFormat: '{point.x}<br>',
                    pointFormat: '<strong>$ {point.y}',
                    shared: true,
                    style: {
                        fontSize: window.innerWidth > 1400 ? ".8vw" : "12px",
                    }
                },
                series: [{
                    name: '$',
                    data: [],
                    marker: {
                        enable: false,
                        fillColor: '#91BDFF',
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    },
                }]
            },
            chartOptionsPie: {
                credits: false,
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    backgroundColor: 'transparent',
                },
                title: {
                    text: 'adsad',
                    align: 'center',
                    verticalAlign: 'middle',
                    y: 0,
                    style: {"color": "#92B8F1", "fontSize": window.innerWidth > 1400 ? "1vw" : "12px"}
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
                    style: {
                        fontSize: window.innerWidth > 1400 ? ".8vw" : "12px",
                    }
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        borderWidth: 0,
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                        }
                    }
                },
                legend: {
                    enabled: true,
                    itemStyle: {"fontWeight": "normal", "fontSize": window.innerWidth > 1400 ? ".7vw" : "12px"}
                },
                series: [{
                    name: 'Orders',
                    colorByPoint: true,
                    innerSize: '60%',
                    showInLegend: true,

                    data: [
                        {
                            name: '',
                            y: 1,
                            color: {
                                linearGradient: {x1: 0, x2: 0, y1: 0, y2: 1},
                                stops: [
                                    [0, '#DDE120'], // start
                                    [1, '#338C27'] // end
                                ]
                            },
                        },
                        {
                            name: '',
                            y: 1,
                            color: {
                                linearGradient: {x1: 0, x2: 0, y1: 0, y2: 1},
                                stops: [
                                    [0, '#B41717'], // start
                                    [1, '#2A6DBC'] // end
                                ]
                            },

                        }
                    ]
                }]
            },
            showEquityHeader: SHOW_EQUITY_HEADER,
            hideTotalDeposits: HIDE_TOTAL_DEPOSITS,
            totalsWrapperCount: 0,
            selectedAccount: null,
            disableSelectedAccount: false
        }
    },
    methods: {
        ...mapActions(["dashboardStatsGet"]),
        currencySign,
        changeAccount(id) {
            if(!id) {
                return
            }

            this.selectedAccount = id;

            this.disableSelectedAccount = true;
            this.dashboardStatsGet({id}).then(()=>{
                this.disableSelectedAccount = false;
            })

        },
         updateTotalsWrapperCount() {
            this.$nextTick(() => {
                if (this.$refs.totalsWrapper) {
                    this.totalsWrapperCount = this.$refs.totalsWrapper.children.length;
                }
            });
        },
        close() {
            this.$store.commit(MODAL, {
                fullscreen: false
            })
        },
        changeTimeframe(timeframe, time) {
            if (this.time !== time) {
                this.time = time
                this.timeframe = timeframe
                this.$store.dispatch(DASHBOARD_BALANCE, this.time * 24)

                this.chartOptionsLine.series[0].data = this.getTimeframeData
                this.foundMinMax()
            }
        },
        foundMinMax() {
            this.chartOptionsLine.yAxis.min = Math.min.apply(null, this.chartOptionsLine.series[0].data)
            this.chartOptionsLine.yAxis.max = Math.max.apply(null, this.chartOptionsLine.series[0].data)
        },
        makeActive(id) {
            this.$store.commit(MODAL, {
                fullscreen: false
            })
            localStorage.setItem('activeAccount', id)
            this.$store.commit(ACCOUNT_ACTIVE, id)
        },
        dashboardChartInit() {
            this.chartOptionsPie.series[0].data[0].y = this.dashboardData.stats.cnt_profit ? parseInt(this.dashboardData.stats.cnt_profit) : 0
            this.chartOptionsPie.series[0].data[1].y = this.cntTotal ? ((this.cntTotal - this.dashboardData.stats.cnt_profit) === 0) ? 0 : ((this.cntTotal) - (this.dashboardData.stats.cnt_profit)) : 1
            let result = (this.chartOptionsPie.series[0].data[0].y / this.cntTotal === 0) ? 0 : (this.chartOptionsPie.series[0].data[0].y / this.cntTotal) * 100

            this.chartOptionsPie.title.text = isNaN(result) ? "0%" : result.toFixed(1) + "%"
            this.chartOptionsLine.xAxis.categories = this.getTimeData

            this.chartOptionsPie.series[0].data[0].name = this.tokens.fullScreenDashboard.closedWithProfit
            this.chartOptionsPie.series[0].data[1].name = this.tokens.fullScreenDashboard.closedWithLoss

            this.chartOptionsPie.legend.itemStyle.color = '#235fb7'
        },
        isOneAccountCurrency(accounts, accountsValue) {
            let isOneAccountCurrency = true

            for (let i = 0; i < accounts.length; i++) {
                if (!(accounts[i] === this.activeCurrency && accounts.length === accountsValue.length)) {
                    return false
                }
            }

            return isOneAccountCurrency
        },
        convToActiveDashCurrency(value) {
            if (this.activeCurrency !== 'USD' && value) {
                return value / this.conversions[this.activeCurrency]
            }
            return value
        },
        convertToUSD(accountCurrency, accountValue) {
            let res = 0;
            let convRate = 1;

            if (accountCurrency !== 'USD') {
                convRate = this.conversions[accountCurrency];
                res = convRate * accountValue
            } else {
                convRate = this.conversions[accountCurrency]
                res = accountValue / convRate
            }
            return res
        },
        isShowEquity() {
            //crutch for Maxon365, ByronplusGlobal (getEquity, showEquityHeader, div.equity)

            return !!(['stage_sharksoft', 'byronplusglobal'].includes(this.brand) && this.showEquityHeader)
        },

        buildAccountName(account) {
            return `${account.group === 'main' ? 'STANDARD' : account.group.toUpperCase().replace(/_\d+/,"")} ${this.tokens.balanceModal.account}`
        },
    },
    computed: {
        ...mapGetters(['conversions','user', 'tokens', 'modals', 'activeAccount', 'accounts', 'dashboardData', 'symbols', 'orders', 'activeCurrency','taxes','langActive']),
        modernCabinet() {
            return CABINET_DESIGN === 'clean'
        },
        plate() {
            let plate = []
            for (const account in this.accounts) {
                let metal = ['tester','beginner', 'student', 'basic','basicx', 'bronze', 'bronze_plus', 'silver', 'silver_plus', 'gold', 'platinum', 'platinum_plus', 'vip', 'top', 'diamond','aitop','pro','pro_1','pro_2','diamond_2','vip_2','platinum_2','gold_2','corporate','arbitrage','shielded', 'islamic','day_trading', 'non_investor', 'gas_fees','low_leverage', 'demo','astr','canada','business','ai_bot','referral_silver','referral_gold','referral_vip', 'premium', 'momentum', 'essential', 'signature', 'premier', 'eliteblack', 'superclass'].includes(this.accounts[account].group) ? this.accounts[account].group : 'main'
                plate[this.accounts[account].id] = '../image/' + this.platesFolder + '/' + metal + '_plate.png'
            }
            return plate
        },
        getTimeframeData() {

            let dashboardBalance = this.dashboardData.balance_chart
            let data = []
            for (let i = 0; i < dashboardBalance.length; i++) {
                data[i] = dashboardBalance[i][1]
            }
            return data
        },
        getTimeData() {
            let dashboardBalance = this.dashboardData.balance_chart
            let timeData = []
            for (let i = 0; i < dashboardBalance.length; i++) {
                timeData[i] = new Date(dashboardBalance[i][0] - 1000 * 60 * 60).toLocaleString()
            }
            return timeData
        },
        totalBalance() {
            if (!Object.keys(this.dashboardData.stats.account || {}).length) {
                return 0
            }

            let currentAccBalance = (this.dashboardData.stats.account && this.dashboardData.stats.account.balance) || 0;
            let currentAccCurrency = (this.dashboardData.stats.account && this.dashboardData.stats.account.currency) || "USD";

            if (this.activeCurrency === currentAccCurrency) {
                return currentAccBalance
            } else{
                let balanceTotal = this.convertToUSD(currentAccCurrency, currentAccBalance) || 0;
                return this.convToActiveDashCurrency(balanceTotal)
            }
        },
        totalDeposits() {
            let totalDeposits = this.dashboardData.stats.deposits;

            let currentAccDeposits = (this.dashboardData.stats.account && this.dashboardData.stats.deposits) || 0;
            let currentAccCurrency = (this.dashboardData.stats.account && this.dashboardData.stats.account.currency) || "USD";

            if (this.activeCurrency !== currentAccCurrency) {
                let usdDeposit = this.convertToUSD(currentAccCurrency, currentAccDeposits) || 0;
                totalDeposits = this.convToActiveDashCurrency(usdDeposit)
            }

            return Math.max(totalDeposits, 0);
        },
        totalNetDeposits() {
            return (this.totalDeposits - this.totalWithdrawal) || 0
        },
        totalTaxes() {
            if (this.activeCurrency !== 'USD') {
                return this.convToActiveDashCurrency(this.dashboardData.stats.taxes)
            }
            return this.dashboardData.stats.taxes
        },
        pnl() {
            let pnlTotal = 0

            if (!(this.dashboardData.stats.profit)) {
                return 0;
            }

            let currentAccPnl = this.dashboardData.stats.profit || 0;
            let currentAccCurrency = (this.dashboardData.stats.account && this.dashboardData.stats.account.currency) || "USD";

            if (this.activeCurrency === currentAccCurrency) {
                return currentAccPnl;
            } else {
                pnlTotal = this.convertToUSD(currentAccCurrency, currentAccPnl);
                return this.convToActiveDashCurrency(pnlTotal)
            }
        },
        cntTotal() {
            return this.dashboardData.stats.cnt_total || 0;
        },
        getEquity() {
            let b = {
                balance: 0,
                orders: 0,
                profit: 0,
                credit: 0,
                margin: 0,
                equity_apprx: 0
            }

            if (!this.activeAccount.id) {
                return b
            }

            b.balance = this.activeAccount.balance
            b.credit = this.activeAccount.credit

            let marginBySymbol = {}

            for(let n in this.activeAccount.orders) {
                let o = this.activeAccount.orders[n]

                o.easy_amount = o.easy_amount || o.margin

                b.orders += o.easy_amount

                if (marginBySymbol[o.symbol] === undefined) {
                    marginBySymbol[o.symbol] = 0
                }

                marginBySymbol[o.symbol] += o.type % 2 ? -o.margin : o.margin

                if (!this.symbols[o.symbol]) {
                    continue
                }

                b.profit += o.type < 2 ? (o.point * (o.type ? o.price_open - this.symbols[o.symbol].quote.ask : this.symbols[o.symbol].quote.bid - o.price_open) * Math.pow(10, this.symbols[o.symbol].precision) + o.swap + o.commission) : 0
            }

            b.equity = b.balance + b.credit + b.profit
            b.equity_apprx =  b.equity

            return b
        },
        totalWithdrawal() {
            if (!Object.keys(this.dashboardData.stats.account || {}).length) {
                return 0
            }

            let totalWithdrawal = Math.abs(this.dashboardData.stats.total_withdrawals) || 0;
            let currentAccWtd = totalWithdrawal;
            let currentAccCurrency = (this.dashboardData.stats.account && this.dashboardData.stats.account.currency) || "USD";

            if (this.activeCurrency !== currentAccCurrency) {
                let usdWithdrawal = this.convertToUSD(currentAccCurrency, currentAccWtd) || 0;
                totalWithdrawal = this.convToActiveDashCurrency(usdWithdrawal)
            }

            return totalWithdrawal
        },

        totalsWrapperChildren(){
            return this.$refs.totalsWrapper ? this.$refs.totalsWrapper.children.length : 1;
        },

        dashboardAccountCurrency() {
            return (this.dashboardData.stats.account && this.dashboardData.stats.account.currency) || false
        }
    
    },
    watch: {
        modals: {
            deep: true,
            handler() {
                if (this.modals.fullscreen && this.$refs.lineChart && this.$refs.pieChart) {
                    this.$refs.lineChart.chart.reflow();
                    this.$refs.pieChart.chart.reflow();
                }
            }
        },
        dashboardData: {
            deep: true,
            handler() {
                let dashboardBalance = this.dashboardData.balance_chart
                let data = []
                for (let i = 0; i < dashboardBalance.length; i++) {
                    data[i] = dashboardBalance[i][1]
                }

                this.chartOptionsLine.series[0].data = data
                this.foundMinMax()
                this.dashboardChartInit()
            }
        },
        activeAccount: {
            handler() {
                if (this.activeAccount !== undefined) {
                    this.$store.commit(ACTIVE_CURRENCY, localStorage.activeCurrency)
                    this.changeAccount(this.activeAccount.id)
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>

.accounts-select{
    grid-column: 1/9;
    grid-row: 1/3;
    background: var(--background-dark)  !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    div {
        background: var(--background-dark);
        margin-bottom: 0;
    }
    select{
        width: 22vw;
        min-width: max-content;
    }
}

.dashboard {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: auto auto 300px auto;
    gap: 30px;
    align-items: stretch;

    --total-row-height: 120px
}

.dashboard > * {
    border-radius: 10px;
    padding: 20px;
    background: var(--background-dark-mid);
    overflow: hidden;
}

.totals-wrapper{
    grid-column: 1/5;
    grid-row: 3/5;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    padding: 0;
    grid-auto-rows: var(--total-row-height);
    background: transparent;
    align-items: stretch;
    & > *:last-child:nth-child(odd) {
        grid-column: 1 / -1;
    }
}


.total-balance,
.total-withdrawal,
.total-net-deposits,
.total-pnl,
.profitable-orders,
.roi,
.equity {
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
    padding: 20px 5px;
    position: relative;
    background: var(--background-dark-mid);
    border-radius: .5vw;
}

.left {
    width: 55px;
    height: 55px;
}

.left img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

.right {
    text-align: center;
}

.total-pnl {
    position: relative;
}

.total-balance .right span,
.total-withdrawal .right span,
.total-net-deposits .right span,
.roi .right span,
.total-pnl .right span,
.equity .right span {
    position: absolute;
    bottom: 5px;
    right: 50%;
    width: 100%;
    font-weight: 300;
    transform: translateX(50%);
}

.title {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: var(--white-to-black);
    margin-bottom: 10px;
    white-space: nowrap;
}

.value {
    font-weight: 500;
    font-size: 30px;
    color: var(--white-to-black);
    white-space: nowrap;
}

.roi-value {
    background: linear-gradient(180deg, #E3FF72 0%, #3FBC2A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}


.chart-line {
    grid-column: 1/9;
    grid-row: 5/8;
    min-height: 200px;
    max-height: 200px;
}

.equity+.chart-line {
    grid-column: 3/9;
}

.chart-line-head {
    display: grid;
    grid-template-columns: repeat(2, auto);
    place-items: center stretch;
    place-content: space-between;
}

.time {
    display: flex;
}

.time-item {
    margin-right: 8px;
    padding: 3px 10px;
    transition: all .3s ease-in-out;
    cursor: pointer;
    font-size: 14px;
    color: var(--white);
    font-weight: 500;
    border: .5px solid transparent;
}

.time-item.active {
    background-color: #2B834E;
    border: .1vw solid var(--fs-border);
}

.time-item.active h5 {
    font-weight: 400;
}

.time-item:last-child {
    margin-right: 0;
}


.chart-line thead {
    background-color: var(--background);
}

.chart-pie {
    grid-column: 5 / 9;
    grid-row: 3/ 5;
    width: 100%;
    aspect-ratio: 1 / 1;
}

.chart-line h4,
.chart-pie h4 {
    font-weight: 400;
    font-size: 24px;
    color: var(--white-to-black);
}

.account {
    grid-column: span 2;
}

.account.active {
    -webkit-box-shadow: 4px 4px 19px 11px rgba(43, 131, 78, 0.35);
    -moz-box-shadow: 4px 4px 19px 11px rgba(43, 131, 78, 0.35);
    box-shadow: 4px 4px 19px 11px rgba(43, 131, 78, 0.35);
}

.sign {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0F111D;
    font-weight: bold;
    font-size: 1.4em;
    margin-right: 15px;
}

.real .balance {
    background-color: #C4C4C4;
}

.balances {
    display: grid;
    gap: 7px;
    grid-template-columns: repeat(2, 25px);
}

.balances img {
    width: 24px;
    height: 24px;
}

.head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
}

.head h3 {
    font-weight: 600;
    font-size: 20px;
    color: var(--white-to-black);
}

.body .info {
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 15px;
    margin-bottom: 14px;
}

.info h4 {
    font-weight: 300;
    font-size: 18px;
    color: var(--white-to-black);
}

.info .value {
    font-weight: 400;
    font-size: 18px;
    text-align: right;
}

.green-gradient {
    background: linear-gradient(180deg, #E3FF72 0%, #3FBC2A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}

.red-gradient {
    background: linear-gradient(180deg, #ff7282 0%, #bc2a36 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}

.footer button {
    display: block;
    padding: 10px 0;
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    color: var(--white);
    text-align: center;
    text-decoration: none;
}

.footer span.active {
    font-size: 16px;
    display: block;
    text-align: center;
    color: rgb(43, 131, 78);
}

@media (min-width: 1000px) {
    .dashboard {
        grid-template-rows: auto auto 15vw auto;
        gap: 1.5vw;
    }

    .dashboard > * {
        border-radius: .5vw;
        padding: 1vh;
    }

    .totals-wrapper{
        grid-column: 1/5;
        grid-row: 3/5;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        padding: 0;
        grid-template-rows: repeat(auto-fill, 1fr);
        background: transparent;
    }

    .total-balance,
    .total-withdrawal,
    .total-net-deposits,
    .total-pnl,
    .profitable-orders,
    .roi,
    .equity {
        padding: 1vw 0;
    }

    .left {
        width: 2.8vw;
        height: 2.8vw;
    }

    .total-balance .right span,
    .total-withdrawal .right span,
    .total-net-deposits .right span,
    .roi .right span,
    .total-pnl .right span,
    .equity .right span {
        bottom: .3vw;
        font-size: .7vw;
    }

    .title {
        font-size: .8vw;
        margin-bottom: .5vw;
    }

    .value {
        font-size: 1.5vw;
    }


    .time-item {
        margin-right: .4vw;
        padding: .15vw .5vw;
        font-size: .7vw;
        border: .1vw solid transparent;
    }

    .time-item.active {
        border: .1vw solid var(--fs-border);
    }

    .account.active {
        -webkit-box-shadow: .2vw .2vw .9vw .5vw rgba(43, 131, 78, 0.35);
        -moz-box-shadow: .2vw .2vw .9vw .5vw rgba(43, 131, 78, 0.35);
        box-shadow: .2vw .2vw .9vw .5vw rgba(43, 131, 78, 0.35);
    }

    .chart-pie{
        max-height: calc(var(--totals-rows) * var(--total-row-height) + (var(--totals-rows) - 1) * 20px);
        min-height: 100%;
    }

    .chart-line h4,
    .chart-pie h4 {
        font-size: 1vw;
    }

    .balances img {
        width: 1.25vw;
        height: 1.25vw;
    }

    .sign {
        width: 1.3vw;
        height: 1.3vw;
        font-size: 1.3vw;
        margin-right: .7vw;
    }

    .balances {
        gap: .3vw;
        grid-template-columns: repeat(2, 1.3vw);
    }

    .balances img {
        width: 1.25vw;
        height: 1.25vw;
    }

    .head {
        margin-bottom: .4vw;
    }

    .head h3 {
        font-size: 1vw;
    }

    .body .info {
        gap: .7vw;
        margin-bottom: .7vw;
    }

    .info h4 {
        font-size: .9vw;
    }

    .info .value {
        font-size: .9vw;
    }


    .footer button {
        padding: .5vw 0;
        font-size: .9vw;
    }

    .footer span.active {
        font-size: .8vw;
    }
}

@media (max-width: 1400px) {
    .dashboard {
        grid-template-rows: auto auto 250px auto;
    }

    .total-balance,
    .total-withdrawal,
    .total-net-deposits,
    .total-pnl,
    .profitable-orders,
    .roi,
    .equity {
        grid-template-columns: repeat(2, auto);
    }

    .value {
        font-size: 22px;
    }

    .left {
        width: 40px;
        height: 40px;
    }
}

/* ================================ mobile */

.dashboard.mobile {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-auto-rows: auto;
    gap: 20px;
}

.dashboard.mobile > * {
    grid-column: 1/2;
    grid-row: span 1;
}

.dashboard.mobile h4 {
    font-size: 18px;
}

.dashboard.mobile .chart-line,
.dashboard.mobile .chart-pie {
    height: 250px;
}

</style>
